import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { telHref, useSiteSettings } from '../../context/SiteSettingsContext';
import './Footer.css';

const Footer = () => {
  const { contactEmail, contactPhone } = useSiteSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <Truck size={32} />
              <span>Zeal Movers</span>
            </div>
            <p className="footer-tagline">
              Professional Moving and Delivery Service
            </p>
            <p className="footer-description">
              Your trusted partner for stress-free moving. We've been helping families 
              and businesses relocate for over 15 years with professional, reliable service.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/quote">Request a move</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Local Moving</Link></li>
              <li><Link to="/services">Long Distance</Link></li>
              <li><Link to="/services">Commercial Moving</Link></li>
              <li><Link to="/services">Packing Services</Link></li>
              <li><Link to="/services">Storage Solutions</Link></li>
              <li><Link to="/services">Specialty Items</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <a href={telHref(contactPhone)}>{contactPhone}</a>
              </li>
              <li>
                <Mail size={18} />
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>13865 102 Ave, Surrey, BC</span>
              </li>
            </ul>
            <div className="footer-hours">
              <strong>Business Hours:</strong>
              <p>Mon-Fri: 7:00 AM - 5:00 PM</p>
              <p>Sat-Sun: 9:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Zeal Movers. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
